import {
  CardText,
  ClockIconWrapper,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/styles';
import { RoundVM } from 'spw-redux/modules/ou/types';
import moment from 'moment/moment';
import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectProjectRounds } from 'spw-redux/modules/ou/selectors';

type Props = {
  selectedRounds: Omit<RoundVM, 'buildings'>[];
};

const SelectedRoundsRow = ({ selectedRounds }: Props) => {
  const rounds = useSelector(selectProjectRounds);
  const dates = selectedRounds.map((round) => round.date);
  const dateRange = `${moment(dates[0]).format('MMM DD, yyyy')} - ${moment(
    dates[dates.length - 1]
  ).format('MMM DD, yyyy')}`;

  return (
    <CardText style={{ marginBottom: 16 }}>
      <Box display="flex">
        <ClockIconWrapper>
          <img src="/images/icons/clock-icon.svg" alt="Clock icon" />
        </ClockIconWrapper>
        <Box>
          <p>
            <b>
              {selectedRounds.length} of {rounds.length} Rounds
            </b>
          </p>
          <p>{dateRange}</p>
        </Box>
      </Box>
    </CardText>
  );
};

export default SelectedRoundsRow;
